import LockWithCheckmark from '../../src/legacy/LockWithCheckmark';
export default LockWithCheckmark;
